import { StoreFactory } from './StoreFactory';
import { ActionFactory } from './ActionFactory';
export class Form {
    _stores = null;
    _actions = null;
    initialState;
    state;
    listeners;
    validators;
    asyncValidators;
    onChangeValue;
    _id;
    constructor(opts, id) {
        this.listeners = [];
        this.validators = [];
        this.asyncValidators = [];
        this.onChangeValue = [];
        this.initialState = {
            rootErrors: [],
            submitErrors: [],
            submitSuccess: false,
            nbSubmits: 0,
            submitting: false,
            values: opts.initialValues,
            fields: {},
            ...opts,
        };
        this.state = { ...this.initialState };
        this._id = id;
    }
    id() {
        return this._id;
    }
    removeValidator(validator) {
        this.validators = this.validators.filter((v) => {
            return v !== validator;
        });
    }
    addValidator(validator) {
        this.dispatch(validator);
        this.validators = [...this.validators, validator];
        return () => this.removeValidator(validator);
    }
    getValidators() {
        return this.validators;
    }
    removeAsyncValidator(validator) {
        this.asyncValidators = this.asyncValidators.filter((v) => {
            return v !== validator;
        });
    }
    addAsyncValidator(validator) {
        this.asyncValidators = [...this.asyncValidators, validator];
        return () => this.removeAsyncValidator(validator);
    }
    getAsyncValidators() {
        return this.asyncValidators;
    }
    getOnChangeValues() {
        return this.onChangeValue;
    }
    addOnChangeValues(callback) {
        this.onChangeValue = [...this.onChangeValue, callback];
    }
    removeListener(listener) {
        this.listeners = this.listeners.filter((l) => {
            return l !== listener;
        });
    }
    addReadonlyListener(listener) {
        const mutableListener = (state) => {
            listener(state);
            return state;
        };
        return this.addMutableListener(mutableListener);
    }
    addMutableListener(listener) {
        this.listeners = [...this.listeners, listener];
        return () => this.removeListener(listener);
    }
    getInitialState() {
        return this.initialState;
    }
    getState() {
        return this.state;
    }
    dispatch(action) {
        this.state = action(this.state);
        for (const listener of this.listeners) {
            this.state = listener(this.state);
        }
    }
    actions() {
        if (this._actions == null) {
            this._actions = new ActionFactory(this);
        }
        return this._actions;
    }
    stores() {
        if (this._stores == null) {
            this._stores = new StoreFactory(this);
        }
        return this._stores;
    }
    getFieldId(field) {
        return `${this.id()}-${field.getKey()}`;
    }
}
